import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

export function useFormat() {
  const { locale, t } = useI18n();

  const isRtl = computed(() => locale.value === 'ar');

  function money(value) {
    const n = Number(value || 0);
    const currency = t('currency');
    const formatted = n.toLocaleString(locale.value === 'ar' ? 'ar-SA' : 'en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return locale.value === 'ar' ? `${formatted} ${currency}` : `${currency} ${formatted}`;
  }

  function bilingual(obj, key) {
    if (!obj) return '';
    return obj[`${key}_${locale.value}`] || obj[`${key}_en`] || obj[`${key}_ar`] || '';
  }

  return { isRtl, money, bilingual, locale };
}
